import Vue from "vue";
import VueRouter from "vue-router";
import mainLayout from "@/components/mainLayout"
import index from "./modules/index"
import customer from "./modules/customer"
import works from "./modules/works"
import platform from "./modules/platform"
import notice from "./modules/notice"
import agent from "./modules/agent"
import maintain from "./modules/maintain"
import appCenter from "./modules/appCenter" //应用中心
import versionPackage from "./modules/versionPackage" //版本套餐
import orderCenter from "./modules/orderCenter" //订单中心
import userManage from "./modules/userManage" //用户管理
import operation from "./modules/operation"
// import setting from "./modules/setting" //用户管理


import remotecontrol from "./modules/remotecontrol"
Vue.use(VueRouter);

const router = new VueRouter({
    routes:[
        {
            name: '登录',
            path: '/',
            component: ()=>import("@/pages/login/login.vue")
        },
        {
            path:'/admin',
            meta: {title: '速速云签'},
            component: mainLayout,
            children: [
                ...index,
                customer,
                ...works,
                ...platform,
                ...notice,
                ...agent,
                operation,
                ...maintain,
                userManage,
                // setting,
                ...remotecontrol,
                ...appCenter,//应用中心
                ...versionPackage,//版本套餐
                orderCenter, //订单中心
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    window.document.title = "速速云签sass平台";
    next();
})
export default router;
